import App from 'app/app.js';

function LtPayOnlyDetermineAmountDrawerDirective() {
  return {
    restrict: 'E',
    scope: {
      image: '=',
      onInit: '&'
    },
    template:
      '<div class="top-drawer" ' +
      '   ng-init="payOnlyDetermineAmountDrawer.init()" ' +
      '   lt-drawer="payOnlyDetermineAmountDrawer.visible" ' +
      '   lt-drawer-cancellation="payOnlyDetermineAmountDrawer.close()" >' +
      '   <div class="determine-amount-content">' +
      '       <h2 lt-translate="PAY_ONLY_DETERMINE_TOTAL_AMOUNT_LINK"></h2>' +
      '       <p lt-translate="PAY_ONLY_DETERMINE_AMOUNT_DESC" ></p>' +
      '       <div>' +
      '           <img class="determine-amount-img" ' +
      '               ng-src="{{payOnlyDetermineAmountDrawer.getImageUrl()}}" />' +
      '       </div>' +
      '       <div align="center" class="row cancel-link-pad">' +
      '           <div class="cancelSprite">' +
      '               <a id="do-cancel-btn" data-id="text_link" ng-click="payOnlyDetermineAmountDrawer.close()" lt-translate="COMMON_TEXT_CANCEL"></a>' +
      '           </div>' +
      '       </div>' +
      '    </div>' +
      '</div>',
    controller: 'LtPayOnlyDetermineAmountDrawerCtrl',
    controllerAs: 'payOnlyDetermineAmountDrawer'
  };
}

App.directive('ltPayOnlyDetermineAmountDrawer', [LtPayOnlyDetermineAmountDrawerDirective]);
